import { ListOfKSTResponse } from './Api/ListOfKST.response';

export class ListOfKSTEntity extends ListOfKSTResponse {
	public static tryCast(o: any) {
		const ret = new ListOfKSTEntity();
		return Object.assign(ret, o);
	}
}
